import {useState, useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createOCAPIFetch} from '../utills/customFetchOCAPI'

const useFetchLibraryFolders = (urlPath) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const {app: appConfig} = getConfig()

    useEffect(() => {
        if (!urlPath) return
        const fetchData = async () => {
            setLoading(true)
            setError(null)

            const args = [
                {
                    headers: {
                        'x-dw-client-id': appConfig.ocapiAPI.contentAPIKey,
                        'Content-Type': 'application/json'
                    }
                }
            ]

            try {
                const customFetch = createOCAPIFetch(appConfig, urlPath)
                const result = await customFetch('GET', args)
                const jsonRes = await result.json()
                setData(jsonRes)
            } catch (err) {
                setError(err.message || 'An unexpected error occurred')
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [urlPath, appConfig])

    return {data, loading, error}
}

export default useFetchLibraryFolders
